export default __webpack_public_path__ + "static/media/009-scuba diving.d673e028.svg";